import { appendReduxPart } from "infrastructure/store";

import { RoleMembersHistoryFilter } from "./components";
import RoleMembersHistory from "./RoleMembersHistory";
import { roleMembersHistorySaga } from "./RoleMembersHistory.saga";
import { roleMembersHistory } from "./RoleMembersHistory.slice";

export * from "./RoleMembersHistory.actions";
export * from "./RoleMembersHistory.state";

export { RoleMembersHistory, RoleMembersHistoryFilter };

appendReduxPart(
  {
    reducerName: roleMembersHistory.name,
    reducer: roleMembersHistory.reducer
  },
  roleMembersHistorySaga()
);
